import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../../../../services/index";
import { message } from "antd";

/**
 * Hook for fetching VIP list with pagination
 * @param {Object} params - Query parameters
 * @param {number} params.page - Page number
 * @param {number} params.pageSize - Items per page
 * @param {string} params.search - Search term
 */
export const useFetchVIPList = ({ page = 1, pageSize = 10, search = '' } = {}) => {
  return useQuery(
    ["getVIPList", page, pageSize, search],
    async () => {
      try {
        const endpoint = `/api/v1/vip/list?page=${page}&pageSize=${pageSize}&search=${encodeURIComponent(search)}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("ไม่สามารถโหลดข้อมูล VIP ได้");
        throw error;
      }
    },
    {
      keepPreviousData: true,
    }
  );
};

/**
 * Hook for fetching single VIP by ID
 */
export const useFetchVIP = (id) => {
  return useQuery(
    ["getVIP", id],
    async () => {
      try {
        const endpoint = `/api/v1/vip/${id}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("ไม่สามารถโหลดข้อมูล VIP ได้");
        throw error;
      }
    },
    {
      enabled: !!id,
    }
  );
};

/**
 * Hook for creating new VIP
 */
export const useFetchCreateVIP = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/vip`;
      const result = await POST(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("ไม่สามารถสร้างข้อมูล VIP ได้");
      throw error;
    }
  });
};

/**
 * Hook for updating VIP
 */
export const useFetchUpdateVIP = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/vip`;
      const result = await PUT(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("ไม่สามารถแก้ไขข้อมูล VIP ได้");
      throw error;
    }
  });
};

/**
 * Hook for deleting VIP
 */
export const useFetchDeleteVIP = () => {
  return useMutation(async (id) => {
    try {
      const endPoint = `/api/v1/vip/${id}`;
      const result = await DELETE(endPoint);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("ไม่สามารถลบข้อมูล VIP ได้");
      throw error;
    }
  });
};

/**
 * Hook for checking if user is VIP
 */
export const useFetchCheckVIP = () => {
  return useMutation(async (userId) => {
    try {
      const endPoint = `/api/v1/vip/check/${userId}`;
      const { result } = await GET(endPoint);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("ไม่สามารถตรวจสอบ VIP ได้");
      throw error;
    }
  });
};
